import React from 'react';
import classNames from 'classnames';
import styles from './query-layout.module.css';
import {EditorHeaderSkeleton} from '../../../components/editor/editor-header/editor-header-skeleton';
import {QueryEditorSkeleton} from './query-editor/query-editor-skeleton/query-editor-skeleton';

export function QueryLayoutLoading() {
    return (
        <div className={classNames(styles.queryLayout, styles.viewMode)}>
            <EditorHeaderSkeleton />
            <QueryEditorSkeleton />
        </div>
    );
}
